/* Naturealm Tools: Myth vs. Fact — topic filter + search */
(function () {
  var root = document.querySelector('[data-nm]');
  if (!root) return;
  var items = Array.prototype.slice.call(root.querySelectorAll('[data-nm-item]'));
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-nm-topic]'));
  var search = root.querySelector('[data-nm-search]');
  var countEl = root.querySelector('[data-nm-count]');
  var emptyEl = root.querySelector('[data-nm-empty]');
  var topic = '';

  function apply() {
    var q = (search && search.value || '').trim().toLowerCase();
    var n = 0;
    items.forEach(function (it) {
      var okTopic = !topic || it.getAttribute('data-topic') === topic;
      var okText = !q || it.textContent.toLowerCase().indexOf(q) > -1;
      var show = okTopic && okText;
      it.classList.toggle('is-hidden', !show);
      if (show) n++;
    });
    if (countEl) countEl.textContent = n + (n === 1 ? ' myth' : ' myths');
    if (emptyEl) emptyEl.hidden = n > 0;
  }

  chips.forEach(function (c) {
    c.addEventListener('click', function () {
      topic = c.getAttribute('data-nm-topic');
      chips.forEach(function (x) {
        var on = x === c;
        x.classList.toggle('is-on', on);
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      apply();
    });
  });
  if (search) search.addEventListener('input', apply);

  items.forEach(function (it) {
    it.addEventListener('toggle', function () {
      if (!it.open) return;
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'myth_opened', myth: (it.querySelector('.nm-q__text') || {}).textContent });
      } catch (e) {}
    });
  });

  // open a myth from a #hash link, e.g. /pages/mushroom-myths#myth-3
  if (location.hash && /^#myth-\d+$/.test(location.hash)) {
    var t = root.querySelector(location.hash);
    if (t) { t.open = true; t.scrollIntoView({ block: 'center' }); }
  }
  apply();
})();
